module.exports = __webpack_public_path__ + "static/img/struct2.e6c6a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/struct2.png
// module id = I97N
// module chunks = 1